import Hero from "../components/home/Hero";
import ClientsMarquee from "../components/home/ClientsMarquee";
import ServicesGrid from "../components/home/ServicesGrid";
import WhyUs from "../components/home/WhyUs";
import Process from "../components/home/Process";
import BrandStatement from "../components/home/BrandStatement";
import IndustriesSection from "../components/home/IndustriesSection";
import Testimonials from "../components/home/Testimonials";
import CtaSection from "../components/home/CtaSection";
import SectionTransition from "../components/shared/SectionTransition";

export default function Home() {
  return (
    <>
      <Hero />
      <SectionTransition variant="scanline" />
      <ClientsMarquee />
      <SectionTransition variant="wave" />
      <ServicesGrid />
      <SectionTransition variant="orbit" />
      <WhyUs />
      <SectionTransition variant="diagonal" />
      <Process />
      <SectionTransition variant="pulse" />
      <BrandStatement />
      <SectionTransition variant="particles" />
      <IndustriesSection />
      <SectionTransition variant="wave" />
      <Testimonials />
      <SectionTransition variant="scanline" />
      <CtaSection />
    </>
  );
}
